import { ReactComponent as ArrowCornerBottom } from "../../../constants/assets/shared/arrowCornerBottomWhite.svg";

const textContent = {
  upperTitle: "Contacto",
  iconUpperTitle: <ArrowCornerBottom style={{ height: 12, marginLeft: 10 }} />,
  secondaryButtonText: "Ir a formulario",
  description:
    "Completa nuestro formulario para desarrollar un proyecto en conjunto o explorar nuevas aplicaciones de nuestro producto.",
};

export const contactContent = {
  textContent,
};
